import { useMutation } from "@tanstack/react-query";
import { contactImportApi } from "service/crm/api/contactImport";
import { ContactImportRecord } from "types/crm/contactImport";

/**
 * Starts the contact import execution once review is confirmed.
 */
export const useStartContactImportMutation = () =>
  useMutation<ContactImportRecord, unknown, string>({
    mutationFn: contactImportApi.startImport,
  });
